import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerticalLayout from "components/vertical-layout";
import { isAuthenticatedByCookie } from "../../helpers/cookie-utils";

//constants
import { layoutTypes } from "../../constants/layout";

const Authmiddleware = (props) => {

  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }));

  const getLayout = (layoutType) => {
    let Layout = VerticalLayout;
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout;
        break;
      case layoutTypes.HORIZONTAL:
        Layout = VerticalLayout; // Default to VerticalLayout since HorizontalLayout might not exist
        break;
      default:
        break;
    }
    return Layout;
  };

  const Layout = getLayout(layoutType);

  // Check if user is authenticated using cookies
  const isAuthenticated = isAuthenticatedByCookie();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>);
};

export default Authmiddleware;
